// import React, { useEffect, useRef, useState } from "react";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Grid,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   IconButton,
//   MenuItem,
//   DialogActions,
//   DialogContent,
//   Dialog,
//   Autocomplete,
//   TableRow,
//   TableCell,
// } from "@mui/material";
// import {
//   Breadcrumb,
//   CTSinput,
// } from "../../reusableComponent/Reusables";
// import CameraAltSharpIcon from "@mui/icons-material/CameraAltSharp";
// import { useDispatch } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import SaveIcon from "@mui/icons-material/Save";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import FactoryIcon from "@mui/icons-material/Factory";
// import EditIcon from "@mui/icons-material/Edit";
// import CancelIcon from "@mui/icons-material/Cancel";
// import styles from "../../../styles.module.css";
// import productMasterService from "../../../services/masters/productMaster.Service";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import uomMasterService from "../../../services/masters/uomMaster.Service";
// import productionentryService from "../../../services/productionentry.Service";
// import plantMasterService from "../../../services/masters/plantMaster.Service";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import { Html5Qrcode } from "html5-qrcode";
// import dayjs from "dayjs";

// // ── Helpers ───────────────────────────────────────────────────────────────────

// const normalizeResult = (value) => {
//   if (!value) return "";
//   const v = value.trim().replace(/\s+/g, " ").toLowerCase();
//   if (v === "ok") return "Ok";
//   if (v === "not ok") return "Not Ok";
//   return value === "Ok" || value === "Not Ok" ? value : "";
// };

// // Auto-calculate filling duration from HH:MM strings
// const calcFillingDuration = (start, end) => {
//   if (!start || !end) return "";
//   const [sh, sm] = start.split(":").map(Number);
//   const [eh, em] = end.split(":").map(Number);
//   if (isNaN(sh) || isNaN(sm) || isNaN(eh) || isNaN(em)) return "";
//   let diffMins = (eh * 60 + em) - (sh * 60 + sm);
//   if (diffMins < 0) diffMins += 24 * 60;
//   const hours = Math.floor(diffMins / 60);
//   const mins = diffMins % 60;
//   return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
// };

// // ── Shared styles ─────────────────────────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };

// const pageHeaderSx = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
// };

// const pageTitleSx = {
//   fontSize: "16px",
//   fontWeight: 700,
//   color: "#000000",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const backBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#2B6CB0",
//   padding: "7px 14px",
//   border: "1.5px solid #2B6CB0",
//   borderRadius: "7px",
//   background: "#fff",
//   cursor: "pointer",
//   textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };

// const formCardSx = {
//   background: "#fff",
//   border: "1px solid #E2E8F0",
//   overflow: "hidden",
//   mb: 2,
// };

// const sectionHeaderSx = {
//   background: "#1C3A5E",
//   padding: "12px 22px",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const sectionHeaderTitleSx = {
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#fff",
//   letterSpacing: "0.3px",
// };

// const formBodySx = { padding: "20px 22px" };

// const fieldLabelSx = {
//   fontSize: "12px",
//   fontWeight: 600,
//   color: "#2063b6",
//   mb: "4px",
//   display: "flex",
//   alignItems: "center",
//   gap: "4px",
// };

// const colLabelSx = {
//   fontSize: "11px",
//   fontWeight: 700,
//   color: "#718096",
//   letterSpacing: "0.8px",
//   textTransform: "uppercase",
//   mb: 1.5,
//   pb: 0.5,
//   borderBottom: "1px solid #EDF2F7",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {

//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa",
//     height: "36px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//   },
//   "& input": {
//     color: "#1A202C",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };

// const readonlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#F0F4F8",
//   },
// };

// const batchNoInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#F0FFF4",
//     "& fieldset": { borderColor: "#38A169", borderWidth: "1.5px" },
//   },
//   "& input": {
//     ...inputSx["& input"],
//     color: "#1b5e20",
//     fontWeight: 700,
//     fontSize: "13px",
//   },
// };

// const durationInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#EBF4FF",
//     "& fieldset": { borderColor: "#2B6CB0", borderWidth: "1.5px" },
//   },
//   "& input": {
//     ...inputSx["& input"],
//     color: "#1C3A5E",
//     fontWeight: 700,
//     textAlign: "center",
//     letterSpacing: "1px",
//   },
// };

// const formFooterSx = {
//   padding: "18px 24px",
//   background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   gap: "10px",
// };

// const saveBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#4CAF50",
//   color: "#fff",
//   border: "none",
//   fontSize: "14px",
//   fontWeight: 600,
//   textTransform: "none",
//   borderRadius: "8px",
//   fontFamily: "'Inter', Arial, sans-serif",
//   "&:hover": { background: "#028b19" },
//   transition: "all 0.15s ease",
// };

// const cancelBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#E53E3E",
//   color: "#ffffff",
//   border: "none",
//   "&:hover": { background: "#971f16" },
//   fontSize: "14px",
//   fontWeight: 600,
//   borderRadius: "8px",
//   textTransform: "none",
// };

// const menuItemSx = {
//   fontSize: "13px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const ProductionEntryAdd = () => {
//   const dispatch = useDispatch();
//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const plant_id = userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
//   const { handleSubmit } = useForm();
//   const navigate = useNavigate();
//   const urlLocation = useLocation();

//   const editInfo = urlLocation.state;
//   const isEditMode = editInfo && typeof editInfo === "object" && editInfo.entry_id;
//   const editData = isEditMode ? editInfo : null;
//   const editid = editData ? editData.entry_id : null;

//   const [filteredCylinders, setFilteredCylinders] = useState([]);
//   const [isSet, setIsSet] = useState(false);
//   const [product, setProduct] = useState([]);
//   const [cylinder, setCylinder] = useState([]);
//   const [uom, setUom] = useState([]);
//   const [production_entry, setproduction_entry] = useState([]);
//   const [plant, setPlant] = useState([]);
//   const [severity, setSeverity] = useState("info");

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [
//           productData, cylinderData, uomData,
//           productionEntryData, plantData, CustomCylinderData,
//         ] = await Promise.all([
//           productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
//           cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
//           uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
//           productionentryService.getProductionEntryList({ page: 0, size: 999, searchKey: "" }),
//           plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
//           productionentryService.getProductionCylinder(plant_id),
//         ]);
//         setProduct(productData);
//         setCylinder(CustomCylinderData);
//         setUom(uomData);
//         setproduction_entry(productionEntryData);
//         setPlant(plantData);
//       } catch (error) {
//         console.error("Data fetching failed:", error);
//       }
//     }
//     fetchData();
//   }, []);

  

//   const [data, setData] = useState(() => ({
//     entry_no: editData ? editData.entry_no : "",
//     batch_no: editData ? editData.batch_no : "",
//     shift: editData ? editData.shift : "",
//     batch_start_time: editData ? editData.batch_start_time : "",
//     batch_end_time: editData ? editData.batch_end_time : "",
//     filling_duration: editData ? editData.filling_duration : "",
//     prod_code: editData ? editData.prod_code : "",
//     prod_description: editData ? editData.prod_description : "",
//     oprater_type: editData ? editData.oprater_type : userInfo.name || userInfo.user_name || "",
//     entry_date: editData?.entry_date
//       ? dayjs(editData.entry_date).isValid() ? dayjs(editData.entry_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD")
//       : dayjs().format("YYYY-MM-DD"),
//     batch_date: editData?.batch_date
//       ? dayjs(editData.batch_date).isValid() ? dayjs(editData.batch_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD")
//       : dayjs().format("YYYY-MM-DD"),
//     from_location: editData?.from_location || "",
//     to_location: editData?.to_location || "",
//     fin_year: editData
//       ? editData.fin_year
//       : dayjs().month() >= 3
//         ? `${dayjs().year()}-${dayjs().year() + 1}`
//         : `${dayjs().year() - 1}-${dayjs().year()}`,
//     batch_pressure: editData ? editData.batch_pressure : "",
//     acetone: editData ? editData.acetone : "",
//     carbide: editData ? editData.carbide : "",
//     modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     modified_by: editData ? userInfo.user_id : null,
//     created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     created_by: editData ? editData.created_by : userInfo.user_id,
//   }));

//   useEffect(() => {
//     if (isEditMode && editData && product.length > 0 && editData.prod_id) {
//       const foundProduct = product.find(
//         (p) => p.prod_id === editData.prod_id || p.prod_code === editData.prod_code
//       );
//       if (foundProduct && (!data.prod_code || !data.prod_description)) {
//         setData((prev) => ({
//           ...prev,
//           prod_code: foundProduct.prod_code,
//           prod_description: foundProduct.prod_description,
//           prod_id: foundProduct.prod_id,
//         }));
//       }
//     }
//   }, [product, editData, isEditMode]);

//   useEffect(() => {
//     if (isEditMode) return;
//     if (!production_entry || production_entry.length === 0) return;
//     const lastBatchNo = production_entry[0]?.lastBatchNo || "";
//     if (!lastBatchNo || lastBatchNo.length < 3) { setData((prev) => ({ ...prev, batch_no: "" })); return; }
//     const lastThreeDigits = lastBatchNo.slice(-3);
//     const currentSeq = parseInt(lastThreeDigits, 10);
//     if (isNaN(currentSeq)) { setData((prev) => ({ ...prev, batch_no: lastBatchNo })); return; }
//     const nextSeq = currentSeq + 1;
//     const newBatchNo = lastBatchNo.slice(0, -3) + String(nextSeq).padStart(3, "0");
//     setData((prev) => ({ ...prev, batch_no: newBatchNo }));
//   }, [production_entry, isEditMode]);



//   const [tagMap, setTagMap] = useState({});
//   const [openDialog, setOpenDialog] = useState(false);
//   const [isMultiDialog, setIsMultiDialog] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [dialogData, setDialogData] = useState({
//     cyl_no: "", cyl_id: "", tag_no: "",
//     initial_wt: "", final_wt: "", qty_filled: "",
//     uom: "", remarks: "", status: "", note: "",
//   });
//   const [multiDialogData, setMultiDialogData] = useState({ cyl_nos: "" });
//   const [editIndex, setEditIndex] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [isScannerOpen, setIsScannerOpen] = useState(false);
//   const [scanResults, setScanResults] = useState([]);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const qrCodeRegionId = "qr-reader";
//   const html5QrCodeRef = useRef(null);
//   const scannerStateRef = useRef({ isStarting: false, isStopping: false });
//   const lastScanTimeRef = useRef(0);
//   const [singleCylinderInput, setSingleCylinderInput] = useState("");
//   const [multiCylinders, setMultiCylinders] = useState([]);
//   const [modalReadOnly, setModalReadOnly] = useState(false);
//   const [modalCylinderDetails, setModalCylinderDetails] = useState(null);
//   const [child_details, setPeDetails] = useState(() => {
//     if (isEditMode && editData && editData.child_details) {
//       try { return JSON.parse(editData.child_details); } catch { return []; }
//     }
//     return [];
//   });

// useEffect(() => {
//   if (!urlLocation.state?.fromQuality) return;
//   if (!urlLocation.state?.notOkCylinders?.length) return;

//   const timer = setTimeout(() => {
//     const notOkCyls = urlLocation.state.notOkCylinders;
//     setPeDetails(notOkCyls.map((cyl, index) => ({
//       sr_no: index + 1,
//       cyl_no: cyl.cyl_no || "",
//       cyl_id: cyl.cyl_id || "",
//       tag_no: cyl.tag_no || "",
//       initial_wt: "",
//       final_wt: "",
//       qty_filled: "",
//       uom: "KG",
//       remarks: "Quality Not Ok",
//     })));
//     setSuccessMessage("Not Ok cylinders loaded from Quality Entry");
//     setOpenSnackbar(true);
//   }, 1500);

//   return () => clearTimeout(timer);
// }, [urlLocation.state]);
  
//   useEffect(() => {
//   const total = child_details
//     .filter(row => parseFloat(row.qty_filled) > 0)
//     .reduce((sum, row) => sum + parseFloat(row.qty_filled), 0);
//   setData(prev => ({ ...prev, carbide: total > 0 ? total.toFixed(2) : "" }));
// }, [child_details]);


//   useEffect(() => {
//     if (data.prod_code) {
//       const avail = cylinder.filter(
//         (cyl) => cyl.prod_id === product.find((p) => p.prod_code === data.prod_code)?.prod_id
//       );
//       setFilteredCylinders(avail);
//     } else setFilteredCylinders([]);
//   }, [data.prod_code, cylinder, product]);

//   const handleProductChange = (e) => {
//     const selectedProduct = product.find((o) => o.prod_code === e.target.value);
//     setData({
//       ...data,
//       prod_code: selectedProduct ? selectedProduct.prod_code : "",
//       prod_id: selectedProduct ? selectedProduct.prod_id : "",
//       prod_description: selectedProduct ? selectedProduct.prod_description : "",
//     });
//      if (urlLocation.state?.fromQuality) return;
//     if (!isEditMode || !child_details.length) {
//       if (selectedProduct && selectedProduct.prod_id) {
//         const fc = cylinder.filter((cyl) => cyl.prod_id === selectedProduct.prod_id);
//         if (fc.length > 0) {
//           setPeDetails(fc.map((cyl, index) => ({
//             sr_no: index + 1,
//             cyl_no: cyl.cylinder_no || "",
//             cyl_id: cyl.cyl_id || "",
//             tag_no: cyl.tag_no || "",
//             initial_wt: cyl.actual_tare_wt_aft_sol || "",
//             final_wt: cyl.final_wt || "",
//             qty_filled: (parseFloat(cyl.final_wt || 0) - parseFloat(cyl.actual_tare_wt_aft_sol || 0)).toFixed(2) || "",
//             uom: "KG",
//             remarks: "",
//             status: cyl.status || "",
//             note: normalizeResult(cyl.note) || "",
//             owner: cyl.owner || "N/A",
//           })));
//         } else setPeDetails([]);
//       } else setPeDetails([]);
//     }
//   };

//   // ── handleChange: auto-calc filling_duration on start/end time change;
//   //    manual edits to filling_duration are also allowed
//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     let updatedData = { ...data, [name]: value };

//     if (name === "batch_date" && !isEditMode) {
//       const newYYMM = dayjs(value).format("YYMM");
//       const lastBatchNo = production_entry[0]?.lastBatchNo || "";
//       let nextSeq = 1;
//       if (lastBatchNo) {
//         const lastYYMM = lastBatchNo.slice(short_code.length, short_code.length + 4);
//         const lastSeq = parseInt(lastBatchNo.slice(-3), 10);
//         if (!isNaN(lastSeq) && lastYYMM === newYYMM) nextSeq = lastSeq + 1;
//       }
//       updatedData.batch_no = `${short_code}${newYYMM}${String(nextSeq).padStart(3, "0")}`;
//     }

//     // Auto-calc only when start or end time field changes
//     if (name === "batch_start_time" || name === "batch_end_time") {
//       const start = name === "batch_start_time" ? value : updatedData.batch_start_time;
//       const end = name === "batch_end_time" ? value : updatedData.batch_end_time;
//       const calculated = calcFillingDuration(start, end);
//       if (calculated) updatedData.filling_duration = calculated;
//     }

//     setData(updatedData);
//   };

//   const handleDialogChange = ({ target }) => {
//     const { name, value } = target;
//     let upd = { ...dialogData };
//     if (name === "cyl_no") {
//       const sc = cylinder.find((c) => c.cylinder_no === value);
//       upd = {
//         ...upd, cyl_no: value, cyl_id: sc ? sc.cyl_id : "",
//         tag_no: sc ? sc.tag_no : "", tare_wt: sc ? Number(sc.tare_wt).toFixed(2) : "",
//         cyl_capacity: sc ? sc.cyl_capacity : "", status: sc ? sc.status : "",
//         note: sc ? normalizeResult(sc.note) : "", storage: sc ? sc.storage : "",
//         uom: sc ? sc.uom : upd.uom,
//       };
//     } else if (name === "note" || name === "status") {
//       upd = { ...upd, [name]: normalizeResult(value) };
//     } else if (["initial_wt", "final_wt"].includes(name)) {
//       const numericValue = value === "" ? "" : Number(value);
//       upd = { ...upd, [name]: numericValue };
//       const iw = parseFloat(upd.initial_wt) || 0;
//       const fw = parseFloat(upd.final_wt) || 0;
//       upd.qty_filled = (fw - iw).toFixed(2);
//     } else {
//       upd = { ...upd, [name]: value };
//     }
//     setDialogData(upd);
//   };

//   const findCylinderByNoOrTag = (input, cylinderList) => {
//     if (!input) return null;
//     const val = input.trim().toLowerCase();
//     return cylinderList.find(
//       (cyl) =>
//         (cyl.cylinder_no && cyl.cylinder_no.toLowerCase() === val) ||
//         (cyl.tag_no && cyl.tag_no.toLowerCase() === val)
//     );
//   };

//   const handleSingleCylinderInput = (input) => {
//     if (!input) { setSuccessMessage("No input provided!"); setSeverity("error"); setOpenSnackbar(true); return; }
//     const match = findCylinderByNoOrTag(input, cylinder);
//     if (match) {
//       setModalCylinderDetails({ cylinder_no: match.cylinder_no, cyl_id: match.cyl_id, tag_no: match.tag_no, tare_wt: match.tare_wt || "", uom: match.uom || "KG", owner: match.owner || "N/A" });
//       setDialogData((prev) => ({ ...prev, cyl_no: match.cylinder_no, cyl_id: match.cyl_id, tag_no: match.tag_no, initial_wt: match.actual_tare_wt_aft_sol || prev.initial_wt || "", uom: match.uom || "KG", qty_filled: "", final_wt: "", remarks: "" }));
//       setSuccessMessage("Cylinder found!"); setSeverity("success"); setOpenSnackbar(true);
//       setSingleCylinderInput(""); setModalReadOnly(false);
//     } else {
//       setModalCylinderDetails(null); setSuccessMessage("No cylinder found!"); setSeverity("error"); setOpenSnackbar(true);
//     }
//   };

//   const handleMultiCylinderInput = (input) => {
//     if (!input) { setSuccessMessage("No input provided!"); setSeverity("error"); setOpenSnackbar(true); return; }
//     const match = findCylinderByNoOrTag(input, cylinder);
//     if (match) {
//       setMultiCylinders((prev) => {
//         if (prev.some((c) => c.cyl_id === match.cyl_id)) {
//           setSuccessMessage("Already added!"); setSeverity("error"); setOpenSnackbar(true);
//           setMultiDialogData({ cyl_nos: "" }); return prev;
//         }
//         setSuccessMessage("Added!"); setSeverity("success"); setOpenSnackbar(true);
//         setMultiDialogData({ cyl_nos: "" });
//         return [...prev, { ...match, owner: match.owner || "N/A" }];
//       });
//     } else { setSuccessMessage("No cylinder found!"); setSeverity("error"); setOpenSnackbar(true); }
//   };

//   const handleOpenDialog = () => {
//     setDialogData({ cyl_no: "", cyl_id: "", tag_no: "", initial_wt: "", final_wt: "", qty_filled: "", uom: "KG", remarks: "", status: "", note: "" });
//     setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true);
//     setScanResults([]); setSingleCylinderInput(""); setModalCylinderDetails(null); setModalReadOnly(false);
//   };

//   const handleOpenmulDialog = () => {
//     setMultiDialogData({ cyl_nos: "" }); setEditIndex(null); setIsMultiDialog(true); setOpenDialog(true);
//     setScanResults([]); setMultiCylinders([]); setModalCylinderDetails(null); setModalReadOnly(false);
//   };

//   const handleDialogSubmit = () => {
//     stopScanner();
//     let hasError = false;
//     if (isMultiDialog) {
//       if (multiCylinders.length === 0) hasError = true;
//       else { const dups = multiCylinders.filter((cyl) => child_details.some((row) => row.cyl_id === cyl.cyl_id)); if (dups.length > 0) hasError = true; }
//     } else {
//       if (!modalCylinderDetails || !dialogData.initial_wt || isNaN(parseFloat(dialogData.initial_wt)) || !dialogData.final_wt || isNaN(parseFloat(dialogData.final_wt)) || !dialogData.qty_filled || isNaN(parseFloat(dialogData.qty_filled)) || parseFloat(dialogData.qty_filled) <= 0 || !dialogData.uom?.trim()) hasError = true;
//       if (editIndex === null && modalCylinderDetails && child_details.some((row) => row.cyl_id === modalCylinderDetails.cyl_id)) hasError = true;
//     }
//     if (hasError) { setSuccessMessage("Please fill all required fields correctly."); setSeverity("error"); setOpenSnackbar(true); return; }
//     if (isMultiDialog) {
//       const newRows = multiCylinders.map((cyl, index) => ({ sr_no: child_details.length + index + 1, cyl_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no, initial_wt: "", final_wt: "", qty_filled: "", uom: cyl.uom || "KG", remarks: "", status: cyl.status || "", note: cyl.note || "" }));
//       setPeDetails((prev) => [...prev, ...newRows]);
//       setSuccessMessage("Multiple cylinders added."); setSeverity("success"); setOpenSnackbar(true);
//     } else {
//       const newRow = { sr_no: editIndex !== null ? child_details[editIndex].sr_no : child_details.length + 1, cyl_no: modalCylinderDetails.cylinder_no, cyl_id: modalCylinderDetails.cyl_id, tag_no: modalCylinderDetails.tag_no, initial_wt: Number(dialogData.initial_wt).toFixed(2), final_wt: Number(dialogData.final_wt).toFixed(2), qty_filled: Number(dialogData.qty_filled).toFixed(2), uom: dialogData.uom || "KG", remarks: dialogData.remarks, status: dialogData.status || "", note: dialogData.note || "" };
//       if (editIndex !== null) setPeDetails((prev) => prev.map((r, i) => (i === editIndex ? newRow : r)));
//       else setPeDetails((prev) => [...prev, newRow]);
//       setSuccessMessage(editIndex !== null ? "Cylinder updated." : "Cylinder added."); setSeverity("success"); setOpenSnackbar(true);
//     }
//     setOpenDialog(false); setScanResults([]); setSingleCylinderInput([]); setMultiCylinders([]); setModalCylinderDetails(null); setEditIndex(null);
//   };

//   const handleRemoveProductionEntrydetails = (index) => {
//     const values = [...child_details]; values.splice(index, 1); setPeDetails(values);
//   };

//   const handleChangeInput = (e, i) => {
//     const arr = [...child_details]; let result = arr[i];
//     result[e.target.name] = e.target.value;
//     if (e.target.name === "initial_wt" || e.target.name === "qty_filled") {
//       const iw = parseFloat(result.initial_wt) || 0;
//       const qf = parseFloat(result.qty_filled) || 0;
//       result.final_wt = (iw + qf).toFixed(2);
//     }
//     result.sr_no = i + 1; arr[i] = result; setPeDetails(arr); setIsSet(!isSet);
//   };

//   const startScanner = () => {
//     if (scannerStateRef.current.isStarting || scannerStateRef.current.isStopping || isScannerOpen || !openDialog) return;
//     scannerStateRef.current.isStarting = true; setIsScannerOpen(true);
//   };

//   const stopScanner = () => {
//     if (scannerStateRef.current.isStopping || !html5QrCodeRef.current || !html5QrCodeRef.current.isScanning) {
//       setIsScannerOpen(false); scannerStateRef.current.isStarting = false; scannerStateRef.current.isStopping = false; return;
//     }
//     scannerStateRef.current.isStopping = true;
//     html5QrCodeRef.current.stop()
//       .then(() => { html5QrCodeRef.current.clear(); html5QrCodeRef.current = null; setIsScannerOpen(false); scannerStateRef.current.isStopping = false; scannerStateRef.current.isStarting = false; })
//       .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStopping = false; scannerStateRef.current.isStarting = false; });
//   };

//   useEffect(() => {
//     if (!isScannerOpen || !openDialog) { if (html5QrCodeRef.current?.isScanning) stopScanner(); return; }
//     const element = document.getElementById(qrCodeRegionId);
//     if (!element) { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; return; }
//     if (html5QrCodeRef.current?.isScanning) { scannerStateRef.current.isStarting = false; return; }
//     html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);
//     const onQrScanSuccess = (decodedText) => {
//       if (isMultiDialog) handleMultiCylinderInput(decodedText);
//       else { handleSingleCylinderInput(decodedText); stopScanner(); }
//       setScanResults((prev) => [...prev, decodedText]);
//     };
//     html5QrCodeRef.current.start({ facingMode: "environment" }, { fps: 10, qrbox: 250 }, onQrScanSuccess, () => {})
//       .then(() => { scannerStateRef.current.isStarting = false; })
//       .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; });
//     return () => {
//       if (html5QrCodeRef.current?.isScanning && !scannerStateRef.current.isStopping) {
//         try { html5QrCodeRef.current.stop(); html5QrCodeRef.current.clear(); } catch {}
//       }
//     };
//   }, [isScannerOpen, openDialog, isMultiDialog, cylinder, tableData, editIndex]);

//   const handleCloseDialog = () => { stopScanner(); setOpenDialog(false); setScanResults([]); };

//   // const onSubmit = async () => {
//   //   const isAnyFieldEmpty = !data.prod_code || !data.batch_start_time?.trim() || !data.batch_end_time?.trim() || !data.batch_pressure?.trim() ;
//   //   const validRows = child_details.filter((row) => row.qty_filled && row.qty_filled !== "" && !isNaN(parseFloat(row.qty_filled)) && parseFloat(row.qty_filled) > 0);
//   //   if (isAnyFieldEmpty || validRows.length === 0) { setSuccessMessage("Please fill all required fields"); setSeverity("error"); setOpenSnackbar(true); return; }
//   //   const formattedData = { ...data, batch_pressure: parseFloat(data.batch_pressure).toFixed(2), carbide: parseFloat(data.carbide).toFixed(2), acetone: parseFloat(data.acetone).toFixed(2) };
//   //   const pe_Data = { ...formattedData, entry_id: editid, child_details: JSON.stringify(validRows), changedUpdatedValue: "edit", unit_id, short_code };
//   //   delete pe_Data.batch_no;
//   //   try {
//   //     if (editData) await productionentryService.editDeleteProductionEntry(pe_Data);
//   //     else await productionentryService.addProductionEntry(pe_Data);
//   //     setSuccessMessage(editData ? "Updated successfully" : "Added successfully"); setSeverity("success"); setOpenSnackbar(true);
//   //     setTimeout(() => { setOpenSnackbar(false); navigate(-1); }, 3000);
//   //   } catch (error) { setSuccessMessage("Error occurred during submission"); setSeverity("error"); setOpenSnackbar(true); }
//   // };
// const onSubmit = async () => {
//   console.log("Submit triggered", data, child_details); // debug ke liye

//   const isAnyFieldEmpty = 
//     !data.prod_code || 
//     !data.batch_start_time?.trim() || 
//     !data.batch_end_time?.trim() || 
//     !data.batch_pressure?.trim();
//     // acetone aur carbide hata diye — carbide auto-calc hai, acetone field UI mein nahi hai

//   const validRows = child_details.filter((row) => 
//     row.qty_filled && 
//     row.qty_filled !== "" && 
//     !isNaN(parseFloat(row.qty_filled)) && 
//     parseFloat(row.qty_filled) > 0
//   );

//   if (isAnyFieldEmpty || validRows.length === 0) { 
//     setSuccessMessage("Please fill all required fields"); 
//     setSeverity("error"); 
//     setOpenSnackbar(true); 
//     return; 
//   }

//   const carbideValue = parseFloat(data.carbide) || 0;
//   const acetoneValue = parseFloat(data.acetone) || 0;

//   const formattedData = { 
//     ...data, 
//     batch_pressure: parseFloat(data.batch_pressure).toFixed(2), 
//     carbide: carbideValue.toFixed(2),   // NaN crash fix
//     acetone: acetoneValue.toFixed(2),   // NaN crash fix
//   };

//   const pe_Data = { 
//     ...formattedData, 
//     entry_id: editid, 
//     child_details: JSON.stringify(validRows), 
//     changedUpdatedValue: "edit", 
//     unit_id, 
//     short_code 
//   };
//   delete pe_Data.batch_no;

//   try {
//     if (editData) await productionentryService.editDeleteProductionEntry(pe_Data);
//     else await productionentryService.addProductionEntry(pe_Data);
//     setSuccessMessage(editData ? "Updated successfully" : "Added successfully"); 
//     setSeverity("success"); 
//     setOpenSnackbar(true);
//     setTimeout(() => { setOpenSnackbar(false); navigate(-1); }, 3000);
//   } catch (error) { 
//     console.error("Submit error:", error);
//     setSuccessMessage("Error occurred during submission"); 
//     setSeverity("error"); 
//     setOpenSnackbar(true); 
//   }
// };
//   const shiftOptions = [
//     { label: "Shift 1", value: "shift1" },
//     { label: "Shift 2", value: "shift2" },
//     { label: "Shift 3", value: "shift3" },
//   ];

//   const acInput = (params, placeholder = "") => (
//     <TextField {...params} size="small" fullWidth placeholder={placeholder} sx={inputSx} />
//   );

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>

//         {/* Breadcrumb */}
//         <Box sx={{ fontSize: "12px", color: "#718096", mb: 2, display: "flex", alignItems: "center", gap: "6px" }}>
//           <span>Dashboard</span> /{" "}
//           <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Production Entry</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <FactoryIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "ADD"} PRODUCTION ENTRY
//           </Box>
//           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         {/* Last Entry */}
//         {/* {!editData && (
//           <Box sx={{ textAlign: "right", fontSize: "12px", color: "#718096", mb: 1.5 }}>
//             Last Entry No: {production_entry?.length > 0 ? production_entry[0].lastpeEntryNo : 0}
//           </Box>
//         )} */}

//         <form onSubmit={handleSubmit(onSubmit)}>

//           {/* ══ Card: Production Entry Details ══ */}
//           <Box sx={formCardSx}>
//             <Box sx={sectionHeaderSx}>
//               <FactoryIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>PRODUCTION ENTRY DETAILS</Typography>
//             </Box>

//             <Box sx={formBodySx}>
//               {/* Two-column container */}
//               <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

//                 {/* ═══════════ LEFT COLUMN — Product & Plant Info ═══════════ */}
//                 <Grid
//                   item xs={12} md={6}
//                   sx={{ p: 2.5, borderRight: { md: "2px dashed #CBD5E0" }, borderBottom: { xs: "2px dashed #CBD5E0", md: "none" } }}
//                 >
//                   {/* <Typography sx={colLabelSx}>Product &amp; Plant Info</Typography> */}

//                   <Grid container spacing={1.5}>

//                     {/* Product Code */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>
//                         Product Code <span style={{ color: "#E53E3E" }}>*</span>
//                       </Typography>
//                       <Autocomplete
//                         options={product} fullWidth
//                         getOptionLabel={(o) => (typeof o === "string" ? o : o.prod_code)}
//                         value={product.find((p) => p.prod_code === data.prod_code) || null}
//                         onChange={(e, nv) =>
//                           handleProductChange({ target: { name: "prod_code", value: nv ? nv.prod_code : "" } })
//                         }
//                         renderOption={(props, option) => (
//                           <MenuItem {...props} sx={menuItemSx}>{option.prod_code}</MenuItem>
//                         )}
//                         renderInput={(params) => acInput(params, "Select product")}
//                       />
//                     </Grid>

//                     {/* Product Description */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>Product Description</Typography>
//                       <TextField
//                         size="small" fullWidth value={data.prod_description}
//                         sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-filled"
//                       />
//                     </Grid>

//                     {/* Batch Pressure */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>
//                         Batch Pressure <span style={{ color: "#E53E3E" }}>*</span>
//                       </Typography>
//                       <TextField
//                         size="small" fullWidth type="number"
//                         name="batch_pressure" value={data.batch_pressure}
//                         onChange={handleChange} sx={inputSx}
//                         placeholder="Enter pressure" inputProps={{ step: "0.01", min: 0 }}
//                       />
//                     </Grid>

//                     {/* Calcium Carbide */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>
//                         Calcium Carbide (KG) <span style={{ color: "#E53E3E" }}>*</span>
//                       </Typography>
//                    <TextField
//   size="small" fullWidth
//   value={data.carbide}
//   sx={readonlyInputSx}
//   InputProps={{ readOnly: true }}
//   placeholder="Auto-calculated from cylinders"
// />
//                     </Grid>

                
//                     {/* <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Shift</Typography>
//                       <Autocomplete
//                         options={shiftOptions} fullWidth
//                         getOptionLabel={(o) => (typeof o === "string" ? o : o.label)}
//                         value={shiftOptions.find((opt) => opt.value === data.shift) || null}
//                         onChange={(e, nv) =>
//                           handleChange({ target: { name: "shift", value: nv ? nv.value : "" } })
//                         }
//                         renderOption={(props, option) => (
//                           <MenuItem {...props} sx={menuItemSx}>{option.label}</MenuItem>
//                         )}
//                         renderInput={(params) => acInput(params, "Select shift")}
//                       />
//                     </Grid> */}

//                     {/* Operator Name */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>Operator Name</Typography>
//                       <TextField
//                         size="small" fullWidth name="oprater_type"
//                         value={data.oprater_type} sx={readonlyInputSx}
//                         InputProps={{ readOnly: true }} placeholder="Auto-filled"
//                       />
//                     </Grid>

//                   </Grid>
//                 </Grid>

//                 {/* ═══════════ RIGHT COLUMN — Dates & Batch Timing ═══════════ */}
//                 <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC",pl:3.5 }}>
//                   {/* <Typography sx={colLabelSx}>Dates &amp; Batch Timing</Typography> */}

//                   <Grid container spacing={1.5}>

//                     {/* Entry No */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>Entry No</Typography>
//                       <TextField
//                         size="small" fullWidth value={data.entry_no}
//                         sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-generated"
//                       />
//                     </Grid>

//                     {/* Entry Date */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>
//                         Entry Date <span style={{ color: "#E53E3E" }}>*</span>
//                       </Typography>
//                       <DatePicker
//                         format="DD/MM/YYYY"
//                         value={data.entry_date ? dayjs(data.entry_date) : null}
//                         onChange={(nv) =>
//                           handleChange({ target: { name: "entry_date", value: nv ? nv.format("YYYY-MM-DD") : "" } })
//                         }
//                         slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
//                       />
//                     </Grid>

//                     {/* Batch No */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>Batch No</Typography>
//                       <TextField
//                         size="small" fullWidth value={data.batch_no}
//                         sx={batchNoInputSx} InputProps={{ readOnly: true }} placeholder="Auto-generated"
//                       />
//                     </Grid>

//                     {/* Batch Date */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>
//                         Batch Date <span style={{ color: "#E53E3E" }}>*</span>
//                       </Typography>
//                       <DatePicker
//                         format="DD/MM/YYYY"
//                         value={data.batch_date ? dayjs(data.batch_date) : null}
//                         onChange={(nv) =>
//                           handleChange({ target: { name: "batch_date", value: nv ? nv.format("YYYY-MM-DD") : "" } })
//                         }
//                         slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
//                       />
//                     </Grid>

//                     {/* Batch Start Time — text so user can type manually e.g. 08:30 */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>
//                         Batch Start Time <span style={{ color: "#E53E3E" }}>*</span>
//                       </Typography>
//                       <TextField
//                         size="small" fullWidth
//                         type="text"
//                         name="batch_start_time"
//                         value={data.batch_start_time}
//                         onChange={handleChange}
//                         sx={inputSx}
//                         placeholder="HH:MM  e.g. 08:30"
//                         inputProps={{ maxLength: 5 }}
//                       />
//                     </Grid>

//                     {/* Batch End Time — text so user can type manually */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>
//                         Batch End Time <span style={{ color: "#E53E3E" }}>*</span>
//                       </Typography>
//                       <TextField
//                         size="small" fullWidth
//                         type="text"
//                         name="batch_end_time"
//                         value={data.batch_end_time}
//                         onChange={handleChange}
//                         sx={inputSx}
//                         placeholder="HH:MM  e.g. 10:00"
//                         inputProps={{ maxLength: 5 }}
//                       />
//                     </Grid>

//                     {/* Filling Duration — auto-calculated OR manually editable */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>
//                         Filling Duration
//                         <span style={{ fontSize: "10px", color: "#718096", fontWeight: 400, marginLeft: 4 }}>
//                           (auto / manual)
//                         </span>
//                       </Typography>
//                       <TextField
//                         size="small" fullWidth
//                         type="text"
//                         name="filling_duration"
//                         value={data.filling_duration}
//                         onChange={handleChange}
//                         sx={durationInputSx}
//                         placeholder="HH:MM"
//                         inputProps={{ maxLength: 5 }}
//                       />
//                     </Grid>


//                       {/* Shift */}
//                     <Grid item xs={7} sm={5}>
//                       <Typography sx={fieldLabelSx}>Shift</Typography>
//                       <Autocomplete
//                         options={shiftOptions} fullWidth
//                         getOptionLabel={(o) => (typeof o === "string" ? o : o.label)}
//                         value={shiftOptions.find((opt) => opt.value === data.shift) || null}
//                         onChange={(e, nv) =>
//                           handleChange({ target: { name: "shift", value: nv ? nv.value : "" } })
//                         }
//                         renderOption={(props, option) => (
//                           <MenuItem {...props} sx={menuItemSx}>{option.label}</MenuItem>
//                         )}
//                         renderInput={(params) => acInput(params, "Select shift")}
//                       />
//                     </Grid>

//                     {/* Financial Year */}
//                     <Grid item xs={12} sm={6}>
//                       {/* <Typography sx={fieldLabelSx}>Financial Year</Typography> */}
//                       {/* <TextField
//                         size="small" fullWidth value={data.fin_year}
//                         sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-filled"
//                       /> */}
//                     </Grid>

//                   </Grid>
//                 </Grid>

//               </Grid>
//             </Box>
//           </Box>

//           {/* ══ Card: Cylinder Table ══ */}
//           <Box sx={formCardSx}>
//             <TableContainer>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <tr>
//                    {[
//   { label: "Sr No",      align: "center" },
//   { label: "Cyl No",     align: "left"   },
//   { label: "Tag No",     align: "left"   },
//   { label: "UOM",        align: "left"   },
//   { label: "Initial Wt", align: "right"  },
//   { label: "Final Wt",   align: "right"  },
//   { label: "Qty Filled", align: "right"  },
//   { label: "Remarks",    align: "left"   },
//   { label: "Action",     align: "center" },
// ].map(({ label, align }) => (
//   <th
//     key={label}
//     style={{
//       background: "#1C3A5E", color: "#fff",
//       fontSize: "12px", fontWeight: 600,
//       fontFamily: "'Inter', Arial, sans-serif",
//       padding: "10px 12px",
//       borderRight: "1px solid rgba(255,255,255,0.1)",
//       whiteSpace: "nowrap",
//       textAlign: align,
//     }}
//   >
//     {label}
//   </th>
// ))}
                 
//                   </tr>
//                 </TableHead>
//                 <TableBody>
//                   {child_details && child_details.length > 0 ? (
//                     child_details.map((row, index) => (
//                       <tr
//                         key={row.cyl_id || index}
//                         onClick={() => {
//                           setDialogData({ cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", initial_wt: row.initial_wt || "", final_wt: row.final_wt || "", qty_filled: row.qty_filled || "", uom: row.uom || "KG", remarks: row.remarks || "", status: row.status || "", note: row.note || "" });
//                           setModalCylinderDetails({ cylinder_no: row.cyl_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", tare_wt: row.initial_wt || "", uom: row.uom || "KG", owner: row.owner || "N/A" });
//                           setEditIndex(index); setIsMultiDialog(false); setOpenDialog(true);
//                           setScanResults([]); setSingleCylinderInput(""); setModalReadOnly(true);
//                         }}
//                         style={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC", cursor: "pointer", borderBottom: "1px solid #E2E8F0" }}
//                         onMouseEnter={(e) => (e.currentTarget.style.background = "#EBF4FF")}
//                         onMouseLeave={(e) => (e.currentTarget.style.background = index % 2 === 0 ? "#fff" : "#F8FAFC")}
//                       >
//                         <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "center" }}>{row.sr_no}</td>
//                         <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" ,textAlign: "left" }}>{row.cyl_no || row.cylinder_no || ""}</td>
//                         <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" , textAlign: "left" }}>{row.tag_no || ""}</td>
//                         <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#718096" , textAlign: "left"  }}>KG</td>
//                         <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" , textAlign: "right"}}>{row.initial_wt ?? 0}</td>
//                         <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" , textAlign: "right"}}>{row.final_wt ?? 0}</td>
//                         <td style={{ padding: "8px 12px" , textAlign: "right"}}>
//                           <Box sx={{ display: "inline-flex", px: 1.5, py: 0.3, borderRadius: "20px", fontSize: "11px", fontWeight: 700, background: parseFloat(row.qty_filled) > 0 ? "#F0FFF4" : "#F7FAFC", color: parseFloat(row.qty_filled) > 0 ? "#2F855A" : "#A0AEC0" }}>
//                             {row.qty_filled ?? 0}
//                           </Box>
//                         </td>
//                         <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#718096" }}>{row.remarks || ""}</td>
//                         <td style={{ padding: "8px 12px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
//                           <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
//                             <IconButton
//                               size="small"
//                               onClick={() => {
//                                 setDialogData({ cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", initial_wt: row.initial_wt || "", final_wt: row.final_wt || "", qty_filled: row.qty_filled || "", uom: row.uom || "KG", remarks: row.remarks || "", status: row.status || "", note: row.note || "" });
//                                 setModalCylinderDetails({ cylinder_no: row.cyl_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", tare_wt: row.initial_wt || "", uom: row.uom || "KG", owner: row.owner || "N/A" });
//                                 setEditIndex(index); setIsMultiDialog(false); setOpenDialog(true);
//                                 setScanResults([]); setSingleCylinderInput(""); setModalReadOnly(false);
//                               }}
//                               sx={{ color: "#2063b6", "&:hover": { background: "#EBF4FF" }, borderRadius: "6px" }}
//                             >
//                               <EditIcon sx={{ fontSize: "15px" }} />
//                             </IconButton>
//                             <IconButton
//                               size="small"
//                               onClick={() => handleRemoveProductionEntrydetails(index)}
//                               sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}
//                             >
//                               <DeleteForeverIcon sx={{ fontSize: "16px" }} />
//                             </IconButton>
//                           </Box>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={9} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
//                         No cylinders available. Select a product to load cylinders.
//                       </td>
//                     </tr>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
//               <Button type="submit" sx={saveBtnSx}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </Box>

//         </form>

//         {/* ══ Cylinder Dialog ══ */}
//         <Dialog
//           open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth
//           PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}
//         >
//           <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//             {editIndex !== null ? (
//               <Box sx={{ display: "flex", gap: 3 }}>
//                 {[["Cyl No", dialogData.cyl_no || modalCylinderDetails?.cylinder_no], ["Tag No", dialogData.tag_no || modalCylinderDetails?.tag_no], ["Owner", modalCylinderDetails?.owner]].map(([label, val]) => (
//                   <Box key={label}>
//                     <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.6)", fontFamily: "'Inter', Arial, sans-serif" }}>{label}</Typography>
//                     <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>{val || "N/A"}</Typography>
//                   </Box>
//                 ))}
//               </Box>
//             ) : (
//               <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
//                 {isMultiDialog ? "Add Multiple Cylinders" : "Edit Cylinder Details"}
//               </Typography>
//             )}
//             <CancelIcon onClick={handleCloseDialog} sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: 20, "&:hover": { color: "#fff" } }} />
//           </Box>

//           <DialogContent sx={{ pt: 3, pb: 1 }}>
//             {isMultiDialog ? (
//               <Box>
//                 {multiCylinders.length > 0 && (
//                   <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>
//                     <Box sx={{ background: "#F8FAFC", px: 2, py: 1.5, borderBottom: "1px solid #E2E8F0" }}>
//                       <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6" }}>
//                         {multiCylinders.length} Cylinders Ready
//                       </Typography>
//                     </Box>
//                     <Table size="small">
//                       <TableHead>
//                         <TableRow sx={{ background: "#1C3A5E" }}>
//                           {["#", "Cylinder No", "Tag No", ""].map((h) => (
//                             <TableCell key={h} sx={{ color: "#fff", fontSize: "11px", fontWeight: 600, py: 1 }}>{h}</TableCell>
//                           ))}
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {multiCylinders.map((row, idx) => (
//                           <TableRow key={row.cyl_id} sx={{ "&:nth-of-type(even)": { background: "#F8FAFC" } }}>
//                             <TableCell sx={{ fontSize: "12px" }}>{idx + 1}</TableCell>
//                             <TableCell sx={{ fontSize: "12px" }}>{row.cylinder_no}</TableCell>
//                             <TableCell sx={{ fontSize: "12px" }}>{row.tag_no}</TableCell>
//                             <TableCell>
//                               <IconButton size="small" onClick={() => setMultiCylinders((prev) => prev.filter((c) => c.cyl_id !== row.cyl_id))} sx={{ color: "#E53E3E" }}>
//                                 <DeleteForeverIcon sx={{ fontSize: "16px" }} />
//                               </IconButton>
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </Box>
//                 )}
//                 {multiCylinders.length === 0 && (
//                   <Box sx={{ py: 4, textAlign: "center", color: "#A0AEC0", fontSize: "13px" }}>
//                     No cylinders added yet. Scan QR codes or enter cylinder numbers.
//                   </Box>
//                 )}
//               </Box>
//             ) : (
//               <Grid container spacing={2.5}>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Initial Wt <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <TextField size="small" fullWidth type="text" name="initial_wt" value={dialogData.initial_wt} onChange={handleDialogChange} sx={inputSx} placeholder="Enter initial weight" />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Final Wt <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <TextField size="small" fullWidth type="number" name="final_wt" value={dialogData.final_wt} onChange={handleDialogChange} sx={inputSx} placeholder="Enter final weight" />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>Qty Filled</Typography>
//                   <TextField size="small" fullWidth type="number" name="qty_filled" value={dialogData.qty_filled} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-calculated" />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={fieldLabelSx}>UOM</Typography>
//                   <TextField size="small" fullWidth value="KG" sx={readonlyInputSx} InputProps={{ readOnly: true }} />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography sx={fieldLabelSx}>Remarks</Typography>
//                   <TextField size="small" fullWidth type="text" name="remarks" value={dialogData.remarks} onChange={handleDialogChange} sx={inputSx} placeholder="Enter remarks (optional)" />
//                 </Grid>
//               </Grid>
//             )}
//           </DialogContent>

//           <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
//             <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
//             <Button onClick={handleDialogSubmit} sx={saveBtnSx}>Done</Button>
//           </DialogActions>
//         </Dialog>

//         <ReusableSnackbar
//           open={openSnackbar}
//           onClose={(e, reason) => { if (reason !== "clickaway") { setOpenSnackbar(false); setSuccessMessage(null); } }}
//           message={successMessage}
//           severity={severity}
//           autoHideDuration={3000}
//           vertical="top"
//           horizontal="right"
//         />

//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default ProductionEntryAdd;

import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  IconButton,
  MenuItem,
  DialogActions,
  DialogContent,
  Dialog,
  Autocomplete,
  TableRow,
  TableCell,
} from "@mui/material";
import {
  Breadcrumb,
  CTSinput,
} from "../../reusableComponent/Reusables";
import CameraAltSharpIcon from "@mui/icons-material/CameraAltSharp";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FactoryIcon from "@mui/icons-material/Factory";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import styles from "../../../styles.module.css";
import SearchIcon from "@mui/icons-material/Search";
import productMasterService from "../../../services/masters/productMaster.Service";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import uomMasterService from "../../../services/masters/uomMaster.Service";
import productionentryService from "../../../services/productionentry.Service";
import plantMasterService from "../../../services/masters/plantMaster.Service";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import { Html5Qrcode } from "html5-qrcode";
import dayjs from "dayjs";
import operatorMasterService from "../../../services/masters/operatorMaster.Service";
// ── Helpers ───────────────────────────────────────────────────────────────────

const normalizeResult = (value) => {
  if (!value) return "";
  const v = value.trim().replace(/\s+/g, " ").toLowerCase();
  if (v === "ok") return "Ok";
  if (v === "not ok") return "Not Ok";
  return value === "Ok" || value === "Not Ok" ? value : "";
};

const getTopupRemark = (cyl) =>
  String(cyl?.status || "").trim().toLowerCase() === "full" &&
  String(cyl?.remark || "").trim().toUpperCase() === "TOPUP"
    ? "TOPUP"
    : "";

const calcFillingDuration = (start, end) => {
  if (!start || !end) return "";
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  if (isNaN(sh) || isNaN(sm) || isNaN(eh) || isNaN(em)) return "";
  let diffMins = (eh * 60 + em) - (sh * 60 + sm);
  if (diffMins < 0) diffMins += 24 * 60;
  const hours = Math.floor(diffMins / 60);
  const mins = diffMins % 60;
  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};

// ── Shared styles ─────────────────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 2,
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "20px 22px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const readonlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F4F8",
  },
};

const batchNoInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0FFF4",
    "& fieldset": { borderColor: "#38A169", borderWidth: "1.5px" },
  },
  "& input": {
    ...inputSx["& input"],
    color: "#1b5e20",
    fontWeight: 700,
    fontSize: "13px",
  },
};

const durationInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#EBF4FF",
    "& fieldset": { borderColor: "#2B6CB0", borderWidth: "1.5px" },
  },
  "& input": {
    ...inputSx["& input"],
    color: "#1C3A5E",
    fontWeight: 700,
    textAlign: "center",
    letterSpacing: "1px",
  },
};

const formFooterSx = {
  padding: "18px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  fontFamily: "'Inter', Arial, sans-serif",
  "&:hover": { background: "#028b19" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#ffffff",
  border: "none",
  "&:hover": { background: "#971f16" },
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
};

const menuItemSx = {
  fontSize: "13px",
  fontFamily: "'Inter', Arial, sans-serif",
};

// ─────────────────────────────────────────────────────────────────────────────

const ProductionEntryAdd = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const plant_id = userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
  const { handleSubmit } = useForm();
  const navigate = useNavigate();
  const urlLocation = useLocation();

  const editInfo = urlLocation.state;
  const isEditMode = editInfo && typeof editInfo === "object" && editInfo.entry_id;
  const editData = isEditMode ? editInfo : null;
  const editid = editData ? editData.entry_id : null;

  // // ── fromQuality logic ──────────────────────────────────────────────────────
  // const fromQuality = editInfo?.fromQuality || false;
  // const notOkCylinders = editInfo?.notOkCylinders || [];

  const [filteredCylinders, setFilteredCylinders] = useState([]);
  const [isSet, setIsSet] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [product, setProduct] = useState([]);
  const [cylinder, setCylinder] = useState([]);
  const [uom, setUom] = useState([]);
  const [production_entry, setproduction_entry] = useState([]);
  const [plant, setPlant] = useState([]);
  const [severity, setSeverity] = useState("info");
  const [operatorList, setOperatorList] = useState([]);



  useEffect(() => {
    async function fetchData() {
      try {
        const [
          productData, cylinderData, uomData,
          productionEntryData, plantData, CustomCylinderData, operatorData
        ] = await Promise.all([
          productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
          cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
          uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
          productionentryService.getProductionEntryList({ page: 0, size: 999, searchKey: "" }),
          plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
          productionentryService.getProductionCylinder(plant_id),
          operatorMasterService.getOperatorList({ page: 0, size: 999, searchKey: "" }),
        ]);
        setProduct(productData);
        setCylinder(CustomCylinderData);
        setUom(uomData);
        setproduction_entry(productionEntryData);
        setproduction_entry(productionEntryData);
        setOperatorList(Array.isArray(operatorData) ? operatorData : []);

// ✅ entry_no generation for ADD mode only
if (!isEditMode) {
  // lastEntryNo is available directly: "PR/SP/26-27/0030"
  const lastEntryNo = productionEntryData?.[0]?.lastEntryNo ?? "";
  const parts = String(lastEntryNo).split("/");
  const lastSeq = parseInt(parts[parts.length - 1]) || 0;
  const nextSeq = lastSeq + 1;

  // Short year: "26-27"
  const yr = dayjs();
  const finYear = yr.month() >= 3
    ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
    : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;

  const formattedEntryNo = `PR/${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;

  setData(prev => ({
    ...prev,
    entry_no: formattedEntryNo,
  }));
}
        setPlant(plantData);
      } catch (error) {
        console.error("Data fetching failed:", error);
      }
    }
    fetchData();
  }, []);

  const [data, setData] = useState(() => ({
    entry_no: editData ? editData.entry_no : "",
    batch_no: editData ? editData.batch_no : "",
    shift: editData ? editData.shift : "",
    batch_start_time: editData ? editData.batch_start_time : "",
    batch_end_time: editData ? editData.batch_end_time : "",
    filling_duration: editData ? editData.filling_duration : "",
    prod_code: editData ? editData.prod_code : "",
    prod_description: editData ? editData.prod_description : "",
    oprater_type: editData ? editData.oprater_type : userInfo.name || userInfo.user_name || "",
    entry_date: editData?.entry_date
      ? dayjs(editData.entry_date).isValid() ? dayjs(editData.entry_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD"),
    batch_date: editData?.batch_date
      ? dayjs(editData.batch_date).isValid() ? dayjs(editData.batch_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD"),
    from_location: editData?.from_location || "",
    to_location: editData?.to_location || "",
    fin_year: editData
      ? editData.fin_year
      : dayjs().month() >= 3
        ? `${dayjs().year()}-${dayjs().year() + 1}`
        : `${dayjs().year() - 1}-${dayjs().year()}`,
    batch_pressure: editData ? editData.batch_pressure : "",
    acetone: editData ? editData.acetone : "",
    carbide: editData ? editData.carbide : "",
    modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    modified_by: editData ? userInfo.user_id : null,
    created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    created_by: editData ? editData.created_by : userInfo.user_id,
  }));

  useEffect(() => {
    if (isEditMode && editData && product.length > 0 && editData.prod_id) {
      const foundProduct = product.find(
        (p) => p.prod_id === editData.prod_id || p.prod_code === editData.prod_code
      );
      if (foundProduct && (!data.prod_code || !data.prod_description)) {
        setData((prev) => ({
          ...prev,
          prod_code: foundProduct.prod_code,
          prod_description: foundProduct.prod_description,
          prod_id: foundProduct.prod_id,
        }));
      }
    }
  }, [product, editData, isEditMode]);

  useEffect(() => {
    if (isEditMode) return;
    if (!production_entry || production_entry.length === 0) return;
    const lastBatchNo = production_entry[0]?.lastBatchNo || "";
    if (!lastBatchNo || lastBatchNo.length < 3) { setData((prev) => ({ ...prev, batch_no: "" })); return; }
    const lastThreeDigits = lastBatchNo.slice(-3);
    const currentSeq = parseInt(lastThreeDigits, 10);
    if (isNaN(currentSeq)) { setData((prev) => ({ ...prev, batch_no: lastBatchNo })); return; }
    const nextSeq = currentSeq + 1;
    const newBatchNo = lastBatchNo.slice(0, -3) + String(nextSeq).padStart(3, "0");
    setData((prev) => ({ ...prev, batch_no: newBatchNo }));
  }, [production_entry, isEditMode]);

  const [tagMap, setTagMap] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [isMultiDialog, setIsMultiDialog] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [dialogData, setDialogData] = useState({
    cyl_no: "", cyl_id: "", tag_no: "",
    initial_wt: "", final_wt: "", qty_filled: "",
    uom: "", remarks: "", status: "", note: "",
  });
  const [multiDialogData, setMultiDialogData] = useState({ cyl_nos: "" });
  const [editIndex, setEditIndex] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [scanResults, setScanResults] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const qrCodeRegionId = "qr-reader";
  const html5QrCodeRef = useRef(null);
  const scannerStateRef = useRef({ isStarting: false, isStopping: false });
  const lastScanTimeRef = useRef(0);
  const [singleCylinderInput, setSingleCylinderInput] = useState("");
  const [multiCylinders, setMultiCylinders] = useState([]);
  const [modalReadOnly, setModalReadOnly] = useState(false);
  const [modalCylinderDetails, setModalCylinderDetails] = useState(null);

  // ── child_details init: fromQuality > editMode > empty ────────────────────
  const [child_details, setPeDetails] = useState(() => {
    // ✅ FIX 1: fromQuality cylinders seedha load karo
    // if (fromQuality && notOkCylinders.length > 0) {
    //   return notOkCylinders.map((cyl, index) => ({
    //     sr_no: index + 1,
    //     cyl_no: cyl.cyl_no || "",
    //     cyl_id: cyl.cyl_id || "",
    //     tag_no: cyl.tag_no || "",
    //     initial_wt: "",
    //     final_wt: "",
    //     qty_filled: "",
    //     uom: "KG",
    //     remarks: "Quality Not Ok",
    //     status: "",
    //     note: "",
    //   }));
    // }
    if (isEditMode && editData && editData.child_details) {
      try { return JSON.parse(editData.child_details); } catch { return []; }
    }
    return [];
  });

  // ✅ FIX 2: Agar useState mein load nahi hua toh useEffect se load karo (fallback)
  // useEffect(() => {
  //   if (!fromQuality || !notOkCylinders.length) return;
  //   if (child_details.length > 0) return; // already loaded hai

  //   const rows = notOkCylinders.map((cyl, index) => ({
  //     sr_no: index + 1,
  //     cyl_no: cyl.cyl_no || "",
  //     cyl_id: cyl.cyl_id || "",
  //     tag_no: cyl.tag_no || "",
  //     initial_wt: "",
  //     final_wt: "",
  //     qty_filled: "",
  //     uom: "KG",
  //     remarks: "Quality Not Ok",
  //     status: "",
  //     note: "",
  //   }));
  //   setPeDetails(rows);
  //   setSuccessMessage(`${rows.length} Not Ok cylinder(s) loaded from Quality Entry`);
  //   setSeverity("success");
  //   setOpenSnackbar(true);
  // }, [fromQuality, notOkCylinders]);

  // useEffect(() => {
  //   const total = child_details
  //     .filter(row => parseFloat(row.qty_filled) > 0)
  //     .reduce((sum, row) => sum + parseFloat(row.qty_filled), 0);
  //   setData(prev => ({ ...prev, carbide: total > 0 ? total.toFixed(2) : "" }));
  // }, [child_details]);
  const displayedRows = useMemo(() => {
  if (!searchKey) return child_details;
  const val = searchKey.trim().toLowerCase();
  return child_details.filter(row =>
    row.cyl_no?.toLowerCase().includes(val) ||
    row.tag_no?.toLowerCase().includes(val)
  );
}, [child_details, searchKey]);

  useEffect(() => {
    if (data.prod_code) {
      const avail = cylinder.filter(
        (cyl) => cyl.prod_id === product.find((p) => p.prod_code === data.prod_code)?.prod_id
      );
      setFilteredCylinders(avail);
    } else setFilteredCylinders([]);
  }, [data.prod_code, cylinder, product]);


  useEffect(() => {
    if (isEditMode) return;
    if (child_details.length > 0) return; 
  if (!cylinder || cylinder.length === 0) return;

    setPeDetails(cylinder.map((cyl, index) => ({
      sr_no: index + 1,
      cyl_no: cyl.cylinder_no || "",
      cyl_id: cyl.cyl_id || "",
      tag_no: cyl.tag_no || "",
      initial_wt: cyl.actual_tare_wt_aft_sol || "",
      final_wt: "",
      qty_filled: "",
      uom: "KG",
      remarks: "",
      status: cyl.status || "",
      note: normalizeResult(cyl.note) || "",
     owner: cyl.owner || "N/A",
      cyl_remark: getTopupRemark(cyl), 
   })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cylinder, isEditMode]);

 const handleProductChange = (e) => {
    const selectedProduct = product.find((o) => o.prod_code === e.target.value);
    setData({
      ...data,
      prod_code: selectedProduct ? selectedProduct.prod_code : "",
      prod_id: selectedProduct ? selectedProduct.prod_id : "",
      prod_description: selectedProduct ? selectedProduct.prod_description : "",
    });

    if (!isEditMode || !child_details.length) {
      if (selectedProduct) {
      
        const fc = cylinder; 
        if (fc.length > 0) {
          setPeDetails(fc.map((cyl, index) => ({
            sr_no: index + 1,
            cyl_no: cyl.cylinder_no || "",
            cyl_id: cyl.cyl_id || "",
            tag_no: cyl.tag_no || "",
            initial_wt: cyl.actual_tare_wt_aft_sol || "",
            final_wt: "",
            qty_filled: "",
            uom: "KG",
            remarks: "",
            status: cyl.status || "",
                       note: normalizeResult(cyl.note) || "",
            owner: cyl.owner || "N/A",
            cyl_remark: getTopupRemark(cyl),
          })));
        } else setPeDetails([]);
      } else setPeDetails([]);
    }
  };

  const handleChange = ({ target }) => {
    const { name, value } = target;
    let updatedData = { ...data, [name]: value };

    if (name === "batch_date" && !isEditMode) {
      const newYYMM = dayjs(value).format("YYMM");
      const lastBatchNo = production_entry[0]?.lastBatchNo || "";
      let nextSeq = 1;
      if (lastBatchNo) {
        const lastYYMM = lastBatchNo.slice(short_code.length, short_code.length + 4);
        const lastSeq = parseInt(lastBatchNo.slice(-3), 10);
        if (!isNaN(lastSeq) && lastYYMM === newYYMM) nextSeq = lastSeq + 1;
      }
      updatedData.batch_no = `${short_code}${newYYMM}${String(nextSeq).padStart(3, "0")}`;
    }

    if (name === "batch_start_time" || name === "batch_end_time") {
      const start = name === "batch_start_time" ? value : updatedData.batch_start_time;
      const end = name === "batch_end_time" ? value : updatedData.batch_end_time;
      const calculated = calcFillingDuration(start, end);
      if (calculated) updatedData.filling_duration = calculated;
    }

    setData(updatedData);
  };

  const handleDialogChange = ({ target }) => {
    const { name, value } = target;
    let upd = { ...dialogData };
    if (name === "cyl_no") {
      const sc = cylinder.find((c) => c.cylinder_no === value);
      upd = {
        ...upd, cyl_no: value, cyl_id: sc ? sc.cyl_id : "",
        tag_no: sc ? sc.tag_no : "", tare_wt: sc ? Number(sc.tare_wt).toFixed(2) : "",
        cyl_capacity: sc ? sc.cyl_capacity : "", status: sc ? sc.status : "",
        note: sc ? normalizeResult(sc.note) : "", storage: sc ? sc.storage : "",
        uom: sc ? sc.uom : upd.uom,
      };
    } else if (name === "note" || name === "status") {
      upd = { ...upd, [name]: normalizeResult(value) };
  } else if (["initial_wt", "final_wt"].includes(name)) {
  upd = { ...upd, [name]: value };   
  const iw = parseFloat(name === "initial_wt" ? value : upd.initial_wt) || 0;
  const fw = parseFloat(name === "final_wt" ? value : upd.final_wt) || 0;
  upd.qty_filled = (fw - iw).toFixed(2);

    } else {
      upd = { ...upd, [name]: value };
    }
    setDialogData(upd);
  };

  const findCylinderByNoOrTag = (input, cylinderList) => {
    if (!input) return null;
    const val = input.trim().toLowerCase();
    return cylinderList.find(
      (cyl) =>
        (cyl.cylinder_no && cyl.cylinder_no.toLowerCase() === val) ||
        (cyl.tag_no && cyl.tag_no.toLowerCase() === val)
    );
  };

  const handleSingleCylinderInput = (input) => {
    if (!input) { setSuccessMessage("No input provided!"); setSeverity("error"); setOpenSnackbar(true); return; }
    const match = findCylinderByNoOrTag(input, cylinder);
    if (match) {
      setModalCylinderDetails({ cylinder_no: match.cylinder_no, cyl_id: match.cyl_id, tag_no: match.tag_no, tare_wt: match.tare_wt || "", uom: match.uom || "KG", owner: match.owner || "N/A" });
      setDialogData((prev) => ({ ...prev, cyl_no: match.cylinder_no, cyl_id: match.cyl_id, tag_no: match.tag_no, initial_wt: match.actual_tare_wt_aft_sol || prev.initial_wt || "", uom: match.uom || "KG", qty_filled: "", final_wt: "", remarks: "" }));
      setSuccessMessage("Cylinder found!"); setSeverity("success"); setOpenSnackbar(true);
      setSingleCylinderInput(""); setModalReadOnly(false);
    } else {
      setModalCylinderDetails(null); setSuccessMessage("No cylinder found!"); setSeverity("error"); setOpenSnackbar(true);
    }
  };

  const handleMultiCylinderInput = (input) => {
    if (!input) { setSuccessMessage("No input provided!"); setSeverity("error"); setOpenSnackbar(true); return; }
    const match = findCylinderByNoOrTag(input, cylinder);
    if (match) {
      setMultiCylinders((prev) => {
        if (prev.some((c) => c.cyl_id === match.cyl_id)) {
          setSuccessMessage("Already added!"); setSeverity("error"); setOpenSnackbar(true);
          setMultiDialogData({ cyl_nos: "" }); return prev;
        }
        setSuccessMessage("Added!"); setSeverity("success"); setOpenSnackbar(true);
        setMultiDialogData({ cyl_nos: "" });
        return [...prev, { ...match, owner: match.owner || "N/A" }];
      });
    } else { setSuccessMessage("No cylinder found!"); setSeverity("error"); setOpenSnackbar(true); }
  };

  const handleOpenDialog = () => {
    setDialogData({ cyl_no: "", cyl_id: "", tag_no: "", initial_wt: "", final_wt: "", qty_filled: "", uom: "KG", remarks: "", status: "", note: "" });
    setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true);
    setScanResults([]); setSingleCylinderInput(""); setModalCylinderDetails(null); setModalReadOnly(false);
  };

  const handleOpenmulDialog = () => {
    setMultiDialogData({ cyl_nos: "" }); setEditIndex(null); setIsMultiDialog(true); setOpenDialog(true);
    setScanResults([]); setMultiCylinders([]); setModalCylinderDetails(null); setModalReadOnly(false);
  };

  const handleDialogSubmit = () => {
    stopScanner();
    let hasError = false;
    if (isMultiDialog) {
      if (multiCylinders.length === 0) hasError = true;
      else { const dups = multiCylinders.filter((cyl) => child_details.some((row) => row.cyl_id === cyl.cyl_id)); if (dups.length > 0) hasError = true; }
    } else {
      if (!modalCylinderDetails || !dialogData.initial_wt || isNaN(parseFloat(dialogData.initial_wt)) || !dialogData.final_wt || isNaN(parseFloat(dialogData.final_wt)) || !dialogData.qty_filled || isNaN(parseFloat(dialogData.qty_filled)) || parseFloat(dialogData.qty_filled) <= 0 || !dialogData.uom?.trim()) hasError = true;
      if (editIndex === null && modalCylinderDetails && child_details.some((row) => row.cyl_id === modalCylinderDetails.cyl_id)) hasError = true;
    }
    if (hasError) { setSuccessMessage("Please fill all required fields correctly."); setSeverity("error"); setOpenSnackbar(true); return; }
    if (isMultiDialog) {
      const newRows = multiCylinders.map((cyl, index) => ({ sr_no: child_details.length + index + 1, cyl_no: cyl.cylinder_no, cyl_id: cyl.cyl_id, tag_no: cyl.tag_no, initial_wt: "", final_wt: "", qty_filled: "", uom: cyl.uom || "KG", remarks: "", status: cyl.status || "",note: cyl.note || "", cyl_remark: getTopupRemark(cyl) }));
      setPeDetails((prev) => [...prev, ...newRows]);
      setSuccessMessage("Multiple cylinders added."); setSeverity("success"); setOpenSnackbar(true);
    } else {
      const newRow = { sr_no: editIndex !== null ? child_details[editIndex].sr_no : child_details.length + 1, cyl_no: modalCylinderDetails.cylinder_no, cyl_id: modalCylinderDetails.cyl_id, tag_no: modalCylinderDetails.tag_no, initial_wt: Number(dialogData.initial_wt).toFixed(2), final_wt: Number(dialogData.final_wt).toFixed(2), qty_filled: Number(dialogData.qty_filled).toFixed(2), uom: dialogData.uom || "KG", remarks: dialogData.remarks, status: dialogData.status || "", note: dialogData.note || "",
cyl_remark:
  getTopupRemark(cylinder.find((c) => c.cyl_id === modalCylinderDetails.cyl_id)) ||
  (editIndex !== null ? child_details[editIndex]?.cyl_remark : "") ||
  "" };
      if (editIndex !== null) setPeDetails((prev) => prev.map((r, i) => (i === editIndex ? newRow : r)));
      else setPeDetails((prev) => [...prev, newRow]);
      setSuccessMessage(editIndex !== null ? "Cylinder updated." : "Cylinder added."); setSeverity("success"); setOpenSnackbar(true);
    }
    setOpenDialog(false); setScanResults([]); setSingleCylinderInput([]); setMultiCylinders([]); setModalCylinderDetails(null); setEditIndex(null);
  };

 const handleRemoveProductionEntrydetails = (cylId) => { 
  setPeDetails(prev => prev.filter(row => row.cyl_id !== cylId));
};
  const handleChangeInput = (e, i) => {
    const arr = [...child_details]; let result = arr[i];
    result[e.target.name] = e.target.value;
    if (e.target.name === "initial_wt" || e.target.name === "qty_filled") {
      const iw = parseFloat(result.initial_wt) || 0;
      const qf = parseFloat(result.qty_filled) || 0;
      result.final_wt = (iw + qf).toFixed(2);
    }
    result.sr_no = i + 1; arr[i] = result; setPeDetails(arr); setIsSet(!isSet);
  };

  const startScanner = () => {
    if (scannerStateRef.current.isStarting || scannerStateRef.current.isStopping || isScannerOpen || !openDialog) return;
    scannerStateRef.current.isStarting = true; setIsScannerOpen(true);
  };

  const stopScanner = () => {
    if (scannerStateRef.current.isStopping || !html5QrCodeRef.current || !html5QrCodeRef.current.isScanning) {
      setIsScannerOpen(false); scannerStateRef.current.isStarting = false; scannerStateRef.current.isStopping = false; return;
    }
    scannerStateRef.current.isStopping = true;
    html5QrCodeRef.current.stop()
      .then(() => { html5QrCodeRef.current.clear(); html5QrCodeRef.current = null; setIsScannerOpen(false); scannerStateRef.current.isStopping = false; scannerStateRef.current.isStarting = false; })
      .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStopping = false; scannerStateRef.current.isStarting = false; });
  };

  useEffect(() => {
    if (!isScannerOpen || !openDialog) { if (html5QrCodeRef.current?.isScanning) stopScanner(); return; }
    const element = document.getElementById(qrCodeRegionId);
    if (!element) { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; return; }
    if (html5QrCodeRef.current?.isScanning) { scannerStateRef.current.isStarting = false; return; }
    html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);
    const onQrScanSuccess = (decodedText) => {
      if (isMultiDialog) handleMultiCylinderInput(decodedText);
      else { handleSingleCylinderInput(decodedText); stopScanner(); }
      setScanResults((prev) => [...prev, decodedText]);
    };
    html5QrCodeRef.current.start({ facingMode: "environment" }, { fps: 10, qrbox: 250 }, onQrScanSuccess, () => {})
      .then(() => { scannerStateRef.current.isStarting = false; })
      .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; });
    return () => {
      if (html5QrCodeRef.current?.isScanning && !scannerStateRef.current.isStopping) {
        try { html5QrCodeRef.current.stop(); html5QrCodeRef.current.clear(); } catch {}
      }
    };
  }, [isScannerOpen, openDialog, isMultiDialog, cylinder, tableData, editIndex]);

  const handleCloseDialog = () => { stopScanner(); setOpenDialog(false); setScanResults([]); };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const onSubmit = async () => {
  if (isSubmitting) return;
  const isAnyFieldEmpty =
    !data.batch_start_time?.trim() ||
    !data.batch_end_time?.trim() ||
    !data.batch_pressure?.toString().trim() ||
    isNaN(parseFloat(data.batch_pressure)) ||
    parseFloat(data.batch_pressure) <= 0 ||
    !data.carbide?.toString().trim() ||
    isNaN(parseFloat(data.carbide)) ||
    parseFloat(data.carbide) <= 0 ||
    !data.oprater_type?.toString().trim() ||
    !data.shift?.toString().trim();

    const validRows = child_details.filter((row) =>
      row.qty_filled &&
      row.qty_filled !== "" &&
      !isNaN(parseFloat(row.qty_filled)) &&
      parseFloat(row.qty_filled) > 0
    );

   if (isAnyFieldEmpty || validRows.length === 0) {
      setFieldErrors({
        batch_pressure: !data.batch_pressure?.toString().trim() || isNaN(parseFloat(data.batch_pressure)) || parseFloat(data.batch_pressure) <= 0,
        carbide: !data.carbide?.toString().trim() || isNaN(parseFloat(data.carbide)) || parseFloat(data.carbide) <= 0,
        oprater_type: !data.oprater_type?.toString().trim(),
        shift: !data.shift?.toString().trim(),
      });
      setSuccessMessage("Please fill all required fields");
      setSeverity("error");
      setOpenSnackbar(true);
      return;
    }
    setFieldErrors({});

    const carbideValue = parseFloat(data.carbide) || 0;
    const acetoneValue = parseFloat(data.acetone) || 0;

    const formattedData = {
      ...data,
      batch_pressure: parseFloat(data.batch_pressure).toFixed(2),
      carbide: carbideValue.toFixed(2),
      acetone: acetoneValue.toFixed(2),
    };

    const pe_Data = {
      ...formattedData,
      entry_id: editid,
      child_details: JSON.stringify(validRows),
      changedUpdatedValue: "edit",
      unit_id,
      short_code
    };
   delete pe_Data.batch_no;
    setIsSubmitting(true);

    try {
      if (editData) await productionentryService.editDeleteProductionEntry(pe_Data);
      else await productionentryService.addProductionEntry(pe_Data);
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setSeverity("success");
      setOpenSnackbar(true);
      setTimeout(() => { setOpenSnackbar(false); navigate(-1); }, 3000);
    } catch (error) {
      console.error("Submit error:", error);
      setSuccessMessage("Error occurred during submission");
      setSeverity("error");
      setOpenSnackbar(true);
      setIsSubmitting(false);
    }
  };

  const shiftOptions = [
    { label: "Shift 1", value: "shift1" },
    { label: "Shift 2", value: "shift2" },
    { label: "Shift 3", value: "shift3" },
  ];

  const acInput = (params, placeholder = "") => (
    <TextField {...params} size="small" fullWidth placeholder={placeholder} sx={inputSx} />
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>

        {/* Breadcrumb */}
        <Box sx={{ fontSize: "12px", color: "#718096", mb: 2, display: "flex", alignItems: "center", gap: "6px" }}>
          <span>Dashboard</span> /{" "}
          <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Production Entry</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <FactoryIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} PRODUCTION ENTRY
            {/* ✅ fromQuality badge */}
            {/* {fromQuality && (
              <Box sx={{ ml: 1, px: 1.5, py: 0.3, background: "#FFF3CD", border: "1px solid #FFC107", borderRadius: "6px", fontSize: "11px", fontWeight: 600, color: "#856404" }}>
                From Quality Entry — {notOkCylinders.length} Not Ok Cylinder(s)
              </Box>
            )} */}
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>

          {/* ══ Card: Production Entry Details ══ */}
          <Box sx={formCardSx}>
            <Box sx={sectionHeaderSx}>
              <FactoryIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>PRODUCTION ENTRY DETAILS</Typography>
            </Box>

            <Box sx={formBodySx}>
              <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

                {/* LEFT COLUMN */}
                <Grid item xs={12} md={6} sx={{ p: 2.5, borderBottom: { xs: "2px dashed #CBD5E0", md: "none" } }}>
                  <Grid container spacing={1.5}>

                    {/* <Grid item xs={7} sm={5}>
                       <Typography sx={fieldLabelSx}>Product Code</Typography>
                      <Autocomplete
                        options={product} fullWidth
                        getOptionLabel={(o) => (typeof o === "string" ? o : o.prod_code)}
                        value={product.find((p) => p.prod_code === data.prod_code) || null}
                        onChange={(e, nv) => handleProductChange({ target: { name: "prod_code", value: nv ? nv.prod_code : "" } })}
                        renderOption={(props, option) => (<MenuItem {...props} sx={menuItemSx}>{option.prod_code}</MenuItem>)}
                        renderInput={(params) => acInput(params, "Select product")}
                      />
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Product Description</Typography>
                      <TextField size="small" fullWidth value={data.prod_description} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-filled" />
                    </Grid> */}

                     <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Batch No</Typography>
                      <TextField size="small" fullWidth value={data.batch_no} sx={batchNoInputSx} InputProps={{ readOnly: true }} placeholder="Auto-generated" />
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Batch Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={data.batch_date ? dayjs(data.batch_date) : null}
                        onChange={(nv) => handleChange({ target: { name: "batch_date", value: nv ? nv.format("YYYY-MM-DD") : "" } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
                      />
                    </Grid>

                    <Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Batch Pressure <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <TextField
    size="small" fullWidth type="number" name="batch_pressure"
    value={data.batch_pressure}
    onChange={handleChange}
    sx={inputSx}
    placeholder="Enter pressure"
    inputProps={{ step: "0.01", min: 0 }}
    error={!!fieldErrors.batch_pressure}
    helperText={fieldErrors.batch_pressure ? "Batch Pressure is required" : ""}
    FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
  />
</Grid>

                   <Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Carbide Used <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <TextField
    size="small"
    fullWidth
    type="number"
    name="carbide"
    value={data.carbide}
    onChange={handleChange}
    sx={inputSx}
    placeholder="Enter calcium carbide"
    inputProps={{ step: "0.01", min: 0 }}
    error={!!fieldErrors.carbide}
    helperText={fieldErrors.carbide ? "Calcium Carbide is required" : ""}
    FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
  />
</Grid>
{/* <Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Operator Name <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <TextField
    select
    size="small"
    fullWidth
    name="oprater_type"
    value={data.oprater_type}
    onChange={handleChange}
    sx={inputSx}
    displayEmpty
    error={!!fieldErrors.oprater_type}
    helperText={fieldErrors.oprater_type ? "Operator Name is required" : ""}
    FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
  >
    <MenuItem value="" sx={menuItemSx}>
      <em style={{ color: "#A0AEC0" }}>Select Operator</em>
    </MenuItem>
    {operatorList.map((op) => (
      <MenuItem
        key={op.operator_id}
        value={op.operator_name}
        sx={menuItemSx}
      >
        {op.operator_name}
      </MenuItem>
    ))}
  </TextField>
</Grid> */}

{/* Search Cylinder */}
<Grid item xs={10}>
    <Box sx={{ mt: "auto", pt: 12, width: "100%", maxWidth: "360px" }}></Box>
  <Typography sx={fieldLabelSx}>Search Cylinder</Typography>
  {/* <TextField
    size="small"
    fullWidth
    placeholder="Search by Cyl No or Tag No"
    sx={inputSx}
    onChange={(e) => {
      const val = e.target.value.trim().toLowerCase();
      if (!val) {
        // reset to full list
        setPeDetails(cylinder.map((cyl, index) => ({
          sr_no: index + 1,
          cyl_no: cyl.cylinder_no || "",
          cyl_id: cyl.cyl_id || "",
          tag_no: cyl.tag_no || "",
          initial_wt: cyl.actual_tare_wt_aft_sol || "",
          final_wt: "",
          qty_filled: "",
          uom: "KG",
          remarks: "",
          status: cyl.status || "",
          note: normalizeResult(cyl.note) || "",
          owner: cyl.owner || "N/A",
        })));
        return;
      }
      setPeDetails(prev =>
        prev.filter(row =>
          row.cyl_no?.toLowerCase().includes(val) ||
          row.tag_no?.toLowerCase().includes(val)
        )
      );
    }}
  InputProps={{
  startAdornment: (
    <Box sx={{ 
      display: "flex", 
      alignItems: "center",
      justifyContent: "center",
      background: "#1C3A5E",
      borderRadius: "6px",
      padding: "4px 18px",
      mr: 1,
      ml: "-8px",  // input ke left edge se chipka do
    }}>
      <SearchIcon sx={{ fontSize: 16, color: "#fff" }} />
    </Box>
  ),
}}
  /> */}
  <TextField
  size="small"
  fullWidth
  placeholder="Search by Cyl No or Tag No"
  sx={inputSx}
  value={searchKey}
  onChange={(e) => setSearchKey(e.target.value)}
  InputProps={{
    startAdornment: (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", background: "#1C3A5E", borderRadius: "6px", padding: "4px 18px", mr: 1, ml: "-8px" }}>
        <SearchIcon sx={{ fontSize: 16, color: "#fff" }} />
      </Box>
    ),
  }}
/>
</Grid>

                  </Grid>
                </Grid>

                {/* RIGHT COLUMN */}
                <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}>
                  <Grid container spacing={1.5}>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Entry No</Typography>
                      <TextField size="small" fullWidth value={data.entry_no} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-generated" />
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Entry Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={data.entry_date ? dayjs(data.entry_date) : null}
                        onChange={(nv) => handleChange({ target: { name: "entry_date", value: nv ? nv.format("YYYY-MM-DD") : "" } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
                      />
                    </Grid>

                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Batch No</Typography>
                      <TextField size="small" fullWidth value={data.batch_no} sx={batchNoInputSx} InputProps={{ readOnly: true }} placeholder="Auto-generated" />
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Batch Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={data.batch_date ? dayjs(data.batch_date) : null}
                        onChange={(nv) => handleChange({ target: { name: "batch_date", value: nv ? nv.format("YYYY-MM-DD") : "" } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
                      />
                    </Grid> */}

                  <Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Batch Start Time <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <TextField
    size="small" fullWidth
    type="time"                        // ✅ was "text"
    name="batch_start_time"
    value={data.batch_start_time}
    onChange={handleChange}
    sx={inputSx}
    inputProps={{ step: 60 }}          // ✅ minute steps only
  />
</Grid>
                  <Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Batch End Time <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <TextField
    size="small" fullWidth
    type="time"                        // ✅ was "text"
    name="batch_end_time"
    value={data.batch_end_time}
    onChange={handleChange}
    sx={inputSx}
    inputProps={{ step: 60 }}
  />
</Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>
                        Filling Duration
                        <span style={{ fontSize: "10px", color: "#718096", fontWeight: 400, marginLeft: 4 }}>(auto / manual)</span>
                      </Typography>
                      <TextField size="small" fullWidth type="text" name="filling_duration" value={data.filling_duration} onChange={handleChange} sx={durationInputSx} placeholder="HH:MM" inputProps={{ maxLength: 5 }} />
                    </Grid>

                    <Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Shift <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <Autocomplete
    options={shiftOptions} fullWidth
    getOptionLabel={(o) => (typeof o === "string" ? o : o.label)}
    value={shiftOptions.find((opt) => opt.value === data.shift) || null}
    onChange={(e, nv) => handleChange({ target: { name: "shift", value: nv ? nv.value : "" } })}
    renderOption={(props, option) => (<MenuItem {...props} sx={menuItemSx}>{option.label}</MenuItem>)}
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        fullWidth
        placeholder="Select shift"
        sx={inputSx}
        error={!!fieldErrors.shift}
        helperText={fieldErrors.shift ? "Shift is required" : ""}
        FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
      />
    )}
  />
</Grid>


<Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Operator Name <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <TextField
    select
    size="small"
    fullWidth
    name="oprater_type"
    value={data.oprater_type}
    onChange={handleChange}
    sx={inputSx}
    displayEmpty
    error={!!fieldErrors.oprater_type}
    helperText={fieldErrors.oprater_type ? "Operator Name is required" : ""}
    FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
  >
    {/* <MenuItem value="" sx={menuItemSx}>
      <em style={{ color: "#A0AEC0" }}>Select Operator</em>
    </MenuItem> */}
    {operatorList.map((op) => (
      <MenuItem
        key={op.operator_id}
        value={op.operator_name}
        sx={menuItemSx}
      >
        {op.operator_name}
      </MenuItem>
    ))}
  </TextField>
</Grid>

                  </Grid>
                </Grid>

              </Grid>
            </Box>
          </Box>

          {/* ══ Card: Cylinder Table ══ */}
          <Box sx={formCardSx}>
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <tr>
                    {[
                      { label: "Sr No", align: "center" },
                      { label: "Cyl No", align: "left" },
                      { label: "Tag No", align: "left" },
                      { label: "UOM", align: "left" },
                      { label: "Initial Wt", align: "right" },
                      { label: "Final Wt", align: "right" },
                      { label: "Qty Filled", align: "right" },
                      { label: "Remarks", align: "left" },
                      { label: "Action", align: "center" },
                    ].map(({ label, align }) => (
                      <th key={label} style={{ background: "#1C3A5E", color: "#fff", fontSize: "12px", fontWeight: 600, fontFamily: "'Inter', Arial, sans-serif", padding: "10px 12px", borderRight: "1px solid rgba(255,255,255,0.1)", whiteSpace: "nowrap", textAlign: align }}>
                        {label}
                      </th>
                    ))}
                  </tr>
                </TableHead>
                <TableBody>
                  {displayedRows && displayedRows.length > 0 ? (
  displayedRows.map((row, index) => (
                      <tr
                        key={row.cyl_id || index}
onClick={() => {
  const actualIndex = child_details.findIndex(r => r.cyl_id === row.cyl_id);
  setDialogData({ cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", initial_wt: row.initial_wt || "", final_wt: row.final_wt || "", qty_filled: row.qty_filled || "", uom: row.uom || "KG", remarks: row.remarks || "", status: row.status || "", note: row.note || "" });
  setModalCylinderDetails({ cylinder_no: row.cyl_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", tare_wt: row.initial_wt || "", uom: row.uom || "KG", owner: row.owner || "N/A" });
  setEditIndex(actualIndex); setIsMultiDialog(false); setOpenDialog(true);
  setScanResults([]); setSingleCylinderInput(""); setModalReadOnly(true);
}}
                        style={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC", cursor: "pointer", borderBottom: "1px solid #E2E8F0" }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#EBF4FF")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = index % 2 === 0 ? "#fff" : "#F8FAFC")}
                      >
                        <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "center" }}>{row.sr_no}</td>
                        <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>{row.cyl_no || row.cylinder_no || ""}</td>
                        <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>{row.tag_no || ""}</td>
                        <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#718096", textAlign: "left" }}>KG</td>
                        <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "right" }}>{row.initial_wt ?? 0}</td>
                        <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "right" }}>{row.final_wt ?? 0}</td>
                        <td style={{ padding: "8px 12px", textAlign: "right" }}>
                          <Box sx={{ display: "inline-flex", px: 1.5, py: 0.3, borderRadius: "20px", fontSize: "11px", fontWeight: 700, background: parseFloat(row.qty_filled) > 0 ? "#F0FFF4" : "#F7FAFC", color: parseFloat(row.qty_filled) > 0 ? "#2F855A" : "#A0AEC0" }}>
                            {row.qty_filled ?? 0}
                          </Box>
                        </td>
                        <td style={{ padding: "8px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#718096" }}>{row.remarks || ""}</td>
                        <td style={{ padding: "8px 12px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                          <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
                           <IconButton
  size="small"
  onClick={() => {
    const actualIndex = child_details.findIndex(r => r.cyl_id === row.cyl_id);
    setDialogData({ cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", initial_wt: row.initial_wt || "", final_wt: row.final_wt || "", qty_filled: row.qty_filled || "", uom: row.uom || "KG", remarks: row.remarks || "", status: row.status || "", note: row.note || "" });
    setModalCylinderDetails({ cylinder_no: row.cyl_no || "", cyl_id: row.cyl_id || "", tag_no: row.tag_no || "", tare_wt: row.initial_wt || "", uom: row.uom || "KG", owner: row.owner || "N/A" });
    setEditIndex(actualIndex); setIsMultiDialog(false); setOpenDialog(true);
    setScanResults([]); setSingleCylinderInput(""); setModalReadOnly(false);
  }}
  sx={{ color: "#2063b6", "&:hover": { background: "#EBF4FF" }, borderRadius: "6px" }}
>
  <EditIcon sx={{ fontSize: "15px" }} />
</IconButton><IconButton
  size="small"
  onClick={() => handleRemoveProductionEntrydetails(row.cyl_id)}
  sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}
>
  <DeleteForeverIcon sx={{ fontSize: "16px" }} />
</IconButton>
                          </Box>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
                        {/* {fromQuality ? "Loading Not Ok cylinders..." : "No cylinders available. Select a product to load cylinders."} */}
                      </td>
                    </tr>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
            <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>

        </form>

        {/* ══ Cylinder Dialog ══ */}
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}>
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            {editIndex !== null ? (
              <Box sx={{ display: "flex", gap: 3 }}>
                {[["Cyl No", dialogData.cyl_no || modalCylinderDetails?.cylinder_no], ["Tag No", dialogData.tag_no || modalCylinderDetails?.tag_no], ["Owner", modalCylinderDetails?.owner]].map(([label, val]) => (
                  <Box key={label}>
                    <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.6)", fontFamily: "'Inter', Arial, sans-serif" }}>{label}</Typography>
                    <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>{val || "N/A"}</Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
                {isMultiDialog ? "Add Multiple Cylinders" : "Edit Cylinder Details"}
              </Typography>
            )}
            <CancelIcon onClick={handleCloseDialog} sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: 20, "&:hover": { color: "#fff" } }} />
          </Box>

          <DialogContent sx={{ pt: 3, pb: 1 }}>
            {isMultiDialog ? (
              <Box>
                {multiCylinders.length > 0 && (
                  <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>
                    <Box sx={{ background: "#F8FAFC", px: 2, py: 1.5, borderBottom: "1px solid #E2E8F0" }}>
                      <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6" }}>{multiCylinders.length} Cylinders Ready</Typography>
                    </Box>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ background: "#1C3A5E" }}>
                          {["#", "Cylinder No", "Tag No", ""].map((h) => (
                            <TableCell key={h} sx={{ color: "#fff", fontSize: "11px", fontWeight: 600, py: 1 }}>{h}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {multiCylinders.map((row, idx) => (
                          <TableRow key={row.cyl_id} sx={{ "&:nth-of-type(even)": { background: "#F8FAFC" } }}>
                            <TableCell sx={{ fontSize: "12px" }}>{idx + 1}</TableCell>
                            <TableCell sx={{ fontSize: "12px" }}>{row.cylinder_no}</TableCell>
                            <TableCell sx={{ fontSize: "12px" }}>{row.tag_no}</TableCell>
                            <TableCell>
                              <IconButton size="small" onClick={() => setMultiCylinders((prev) => prev.filter((c) => c.cyl_id !== row.cyl_id))} sx={{ color: "#E53E3E" }}>
                                <DeleteForeverIcon sx={{ fontSize: "16px" }} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                )}
                {multiCylinders.length === 0 && (
                  <Box sx={{ py: 4, textAlign: "center", color: "#A0AEC0", fontSize: "13px" }}>
                    No cylinders added yet. Scan QR codes or enter cylinder numbers.
                  </Box>
                )}
              </Box>
            ) : (
              <Grid container spacing={2.5}>
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>Initial Wt <span style={{ color: "#E53E3E" }}>*</span></Typography>
                  <TextField size="small" fullWidth type="text" name="initial_wt" value={dialogData.initial_wt} onChange={handleDialogChange} sx={inputSx} placeholder="Enter initial weight" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>Final Wt <span style={{ color: "#E53E3E" }}>*</span></Typography>
                  <TextField size="small" fullWidth type="number" name="final_wt" value={dialogData.final_wt} onChange={handleDialogChange} sx={inputSx} placeholder="Enter final weight" />
                  {dialogData.initial_wt !== "" && dialogData.final_wt !== "" &&
                   !isNaN(parseFloat(dialogData.initial_wt)) && !isNaN(parseFloat(dialogData.final_wt)) &&
                 parseFloat(dialogData.final_wt) <= parseFloat(dialogData.initial_wt) && (
                    <Typography sx={{ color: "#E53E3E", fontSize: "11px", mt: 0.5 }}>
                       Final Wt should be greater than Initial Wt
                     </Typography>
                )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>Qty Filled</Typography>
                  <TextField size="small" fullWidth type="number" name="qty_filled" value={dialogData.qty_filled} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-calculated" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>UOM</Typography>
                  <TextField size="small" fullWidth value="KG" sx={readonlyInputSx} InputProps={{ readOnly: true }} />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={fieldLabelSx}>Remarks</Typography>
                  <TextField size="small" fullWidth type="text" name="remarks" value={dialogData.remarks} onChange={handleDialogChange} sx={inputSx} placeholder="Enter remarks (optional)" />
                </Grid>
              </Grid>
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
            <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
            <Button onClick={handleDialogSubmit} sx={saveBtnSx}>Done</Button>
          </DialogActions>
        </Dialog>

        <ReusableSnackbar
          open={openSnackbar}
          onClose={(e, reason) => { if (reason !== "clickaway") { setOpenSnackbar(false); setSuccessMessage(null); } }}
          message={successMessage}
          severity={severity}
          autoHideDuration={3000}
          vertical="top"
          horizontal="right"
        />

      </Box>
    </LocalizationProvider>
  );
};

export default ProductionEntryAdd;